function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "path",
  d: "M7.5 1.50003C10.8 1.50003 13.5 4.18122 13.5 7.50003C13.5 10.8189 10.8188 13.5 7.5 13.5C4.18118 13.5 1.51875 10.8 1.51875 7.50003C1.51875 4.20007 4.19993 1.50003 7.5 1.50003ZM7.5 0C3.35625 0 0 3.375 0 7.5C0 11.6437 3.375 15 7.5 15C11.6437 15 15 11.625 15 7.5C15 3.35625 11.6437 0 7.5 0Z",
  fill: "#317AD0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "path",
  d: "M10.1995 8.25001C10.1995 8.25001 10.1808 8.25001 10.1995 8.25001L4.81829 8.23131C4.40579 8.23131 4.06836 7.89388 4.06836 7.48138C4.06836 7.06888 4.40579 6.73145 4.81829 6.73145L10.1995 6.75015C10.612 6.75015 10.9495 7.08758 10.9495 7.50008C10.9309 7.91258 10.612 8.25001 10.1995 8.25001Z",
  fill: "#317AD0"
});
function SvgIconRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon-remove.9d3e00f1.svg";
export { ForwardRef as ReactComponent };